export default "__VITE_ASSET__DaoxgpRJ__"